"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _oneWeir = require("@weirgroup/one-weir");
var _reactRedux = require("react-redux");
var _languageMsg = _interopRequireDefault(require("./languageMsg"));
var _AddUserToSitesModule = _interopRequireDefault(require("./AddUserToSites.module.css"));
var _AddMineSite = _interopRequireDefault(require("../AddMineSite"));
var _sendMineSiteinvitation = _interopRequireDefault(require("../sendMineSiteinvitation"));
var _manageYourTeam = require("../manageYourTeam.action");
class AddUserToSites extends _react.default.Component {
  static renderStepItem(step, index) {
    return /*#__PURE__*/_react.default.createElement(_oneWeir.MilestoneStep, {
      selected: step.selected,
      active: step.active,
      key: index,
      label: step.name,
      onClick: step.click
    });
  }
  constructor(props) {
    super(props);
    this.handleChangeAppRole = selectedAppRole => {
      this.setState({
        selectedAppRole
      });
    };
    this.handleSendInvitationClick = () => {
      this.state.assignedUsersList.forEach(site => {
        //since the DropdownOptionsList does not support to emit both value & labal we need below function to get businessEntityObjectId
        const buid = this.props.mineSiteList.map(function (bu) {
          if (bu.sourceSystemBusinessEntityDisplayName === site) {
            return bu.businessEntityObjectId;
          } else {
            return null;
          }
        });
        const reqBody = {
          UserEmail: this.props.selectedUser.MineSiteUsersEmail.source,
          AppObjectId: this.props.appinfo.appid,
          AppRoleId: this.state.selectedAppRole.appRoleObjectId,
          BusinessEntityObjectId: buid[0]
        };
        this.props.sendInvitation(reqBody);
      });
    };
    this.removeSite = site => {
      const index = this.state.assignedUsersList.indexOf(site);
      const usersListAssigned = this.state.assignedUsersList;
      if (index > -1) {
        usersListAssigned.splice(index, 1);
      }
      this.setState({
        usersListAssigned
      });
    };
    this.handleNextButtonClick = assignedUsersList => {
      this.setState({
        assignedUsersList
      });
      const steps = this.state.milestoneSteps;
      const milestoneStepsState = this.state.milestoneStepsState;
      this.resetActiveStatus();
      steps[this.state.milestoneStepsState].selected = true;
      steps[this.state.milestoneStepsState + 1].active = true;
      this.setState({
        milestoneSteps: steps,
        milestoneStepsState: milestoneStepsState + 1
      });
    };
    this.state = {
      breadcrumbHistoryData: [],
      milestoneSteps: [{
        step: 0,
        name: _languageMsg.default.SELECT_ROLE_AND_MINE_STEP.replace('<MineSiteLabelPlural>', this.props.mineSiteLabel.plural),
        active: true,
        selected: false,
        click: () => {}
      }, {
        step: 1,
        name: _languageMsg.default.SEND_INVITATION_STEP,
        active: false,
        selected: false,
        click: () => {}
      }],
      milestoneStepsState: 0,
      assignedUsersList: [],
      selectedAppRole: '',
      sendInvitationState: false
    };
    this.renderSendInvitationPanel = this.renderSendInvitationPanel.bind(this);
    this.renderAddSitePanel = this.renderAddSitePanel.bind(this);
    this.handleNextButtonClick = this.handleNextButtonClick.bind(this);
    this.handleSendInvitationClick = this.handleSendInvitationClick.bind(this);
    this.handleChangeAppRole = this.handleChangeAppRole.bind(this);
  }
  componentDidMount() {
    this.breadcrumbInit();
    this.updateMilestoneWorkflow();
  }
  componentDidUpdate(prevProps) {
    if (this.props.sendInvitationStateValue !== prevProps.sendInvitationStateValue) {
      this.setState({
        milestoneStepsState: 0,
        assignedUsersList: [],
        selectedAppRole: '',
        sendInvitationState: true,
        milestoneSteps: [{
          step: 0,
          name: _languageMsg.default.SELECT_ROLE_AND_MINE_STEP.replace('<MineSiteLabelPlural>', this.props.mineSiteLabel.plural),
          active: true,
          selected: false,
          click: () => {}
        }, {
          step: 1,
          name: _languageMsg.default.SEND_INVITATION_STEP,
          active: false,
          selected: false,
          click: () => {}
        }]
      }, () => {
        this.props.sendInvitationState(false);
        this.props.setUserDetails([]);
        this.updateMilestoneWorkflow();
      });
    }
  }
  breadcrumbInit() {
    const breadcrumbHistoryData = [];
    breadcrumbHistoryData.push({
      path: '#',
      title: _languageMsg.default.MANAGE_YOUR_TEAM,
      callbackHandler: () => this.props.navCallback(0)
    });
    breadcrumbHistoryData.push({
      path: '#',
      title: this.props.mineSiteLabel.singular,
      callbackHandler: () => this.props.navCallback(1)
    });
    breadcrumbHistoryData.push({
      path: '#',
      title: this.props.selectedUser.MineSiteUsers.source,
      callbackHandler: () => this.props.navCallback(2)
    });
    breadcrumbHistoryData.push({
      path: '#',
      title: _languageMsg.default.ADD_USERS_TO_MINE_SITES.replace('<MineSiteLabelPlural>', this.props.mineSiteLabel.plural)
    });
    this.setState({
      breadcrumbHistoryData
    });
  }
  updateMilestoneWorkflow() {
    const steps = this.state.milestoneSteps;
    for (let i = 0; i < steps.length; i += 1) {
      steps[i].click = () => {
        if (steps[i].selected) {
          this.resetActiveStatus();
          if (steps[i] === i) {
            steps[i].active = true;
          }
          this.setState({
            milestoneStepsState: steps[i].step
          });
        }
      };
    }
    this.setState({
      milestoneSteps: steps
    });
  }
  resetActiveStatus() {
    const mSteps = this.state.milestoneSteps;
    for (let i = 0; i < mSteps.length; i += 1) {
      mSteps[i].active = false;
    }
    this.setState({
      milestoneSteps: mSteps
    });
  }
  renderSendInvitationPanel() {
    return /*#__PURE__*/_react.default.createElement(_sendMineSiteinvitation.default, {
      onClickSendInvitation: this.handleSendInvitationClick,
      assignUsersValues: this.state.assignedUsersList,
      removeUser: site => this.removeSite(site),
      selectedAppRole: this.state.selectedAppRole,
      selectedBusinessEntity: this.props.selectedBusinessEntity
    });
  }
  renderAddSitePanel() {
    return /*#__PURE__*/_react.default.createElement(_AddMineSite.default, {
      handleNextButtonClick: this.handleNextButtonClick,
      handleChangeAppRole: this.handleChangeAppRole,
      selectedAppRole: this.state.selectedAppRole,
      usersList: this.props.mineSiteList,
      selectedUsersList: this.state.assignedUsersList
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "invite-users-page",
      className: _AddUserToSitesModule.default.wrapper
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "invite-users-breadcrumb"
    }, /*#__PURE__*/_react.default.createElement(_oneWeir.Breadcrumb, {
      breadcrumbHistory: this.state.breadcrumbHistoryData
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _AddUserToSitesModule.default.mBottom
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "invite-users-title",
      className: _AddUserToSitesModule.default.viewUsersHeading
    }, this.props.selectedUser && this.props.selectedUser.MineSiteUsers.source)), /*#__PURE__*/_react.default.createElement("div", {
      className: _AddUserToSitesModule.default.milestoneWrapper
    }, /*#__PURE__*/_react.default.createElement(_oneWeir.MilestoneNavigation, null, this.state.milestoneSteps.map((step, index) => AddUserToSites.renderStepItem(step, index)))), /*#__PURE__*/_react.default.createElement("div", {
      className: _AddUserToSitesModule.default.panels
    }, this.state.milestoneStepsState === 0 ? this.renderAddSitePanel() : '', this.state.milestoneStepsState === 1 ? this.renderSendInvitationPanel() : ''));
  }
}
;
function mapDispatchToProps(dispatch) {
  return {
    sendInvitation: data => {
      dispatch((0, _manageYourTeam.sendInvitation)(data));
    },
    sendInvitationState: stateVal => {
      dispatch((0, _manageYourTeam.sendInvitationState)(stateVal));
    },
    setUserDetails: val => {
      dispatch((0, _manageYourTeam.setUserDetails)(val));
    }
  };
}
;
const mapStateToProps = state => ({
  mineSiteList: state.manageYourTeam.mines,
  sendInvitationStateValue: state.manageYourTeam.sendInvitationState,
  appinfo: state.manageYourTeam.appinfo,
  mineSiteLabel: state.manageYourTeam.mineSiteLabel
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddUserToSites);